import { render } from "./HealthInfoDialog.vue?vue&type=template&id=fe915bd8&scoped=true"
import script from "./HealthInfoDialog.vue?vue&type=script&lang=js"
export * from "./HealthInfoDialog.vue?vue&type=script&lang=js"

import "./HealthInfoDialog.vue?vue&type=style&index=0&id=fe915bd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe915bd8"]])

export default __exports__